// @ts-nocheck
import React, { useState } from "react";
import {
  FaArrowLeft,
  FaArrowRight,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../../../../../ApiClient/GetApi";
import { PostApi } from "../../../../../ApiClient/PostApi";
import { Loader2 } from "../../../../loader/Loader";
import { error_toaster, success_toaster } from "../../../../toaster/Toaster";

export default function OrderBar() {
  const navigate = useNavigate();
  const [pack, setPack] = useState(true);
  const openPack = () => {
    setPack(false);
  };
  const closePack = () => {
    setPack(true);
  };
  const [prod, setProd] = useState(true);
  const openProd = () => {
    setProd(true);
  };
  const closeProd = () => {
    setProd(false);
  };
  const [supp, setSupp] = useState(true);
  const openSupp = () => {
    setSupp(true);
  };
  const closeSupp = () => {
    setSupp(false);
  };
  const [dest, setDest] = useState(true);
  const openDest = () => {
    setDest(true);
  };
  const [consigneeOpen, setConsigneeOpen] = useState(true);
  const openConsignee = () => setConsigneeOpen(true);
  const closeConsignee = () => setConsigneeOpen(false);
  const [visiblePackages, setVisiblePackages] = useState(25);
  const [visibleProducts, setVisibleProducts] = useState(25);
  const closeDest = () => {
    setDest(false);
  };

  const [loading, SetLoading] = useState(false);

  const { data } = useFetch(
    `booking/order_summary/${localStorage.getItem("orderId")}`
  );
  const packages = data?.data?.packages || data?.data?.order?.Packages || [];
  const products = data?.data?.products || data?.data?.order?.Products || [];

  const place_order = async () => {
    SetLoading(true);
    const res = await PostApi("booking/place_order", {
      BookingId: localStorage.getItem("orderId"),
      sendEmailToSupplier: localStorage.getItem("sendEmail")
    });

    if (res.data.status === "1") {
      SetLoading(false);
      success_toaster(res.data.message);
      navigate("/place_order");
      remove_localstorage_fields();
    } else {
      SetLoading(false);
      error_toaster(res.data.message);
    }
  };
  const remove_localstorage_fields = () => {
    //supplier details storage
    localStorage.removeItem("contactName");
    localStorage.removeItem("email");
    localStorage.removeItem("phone");
    localStorage.removeItem("packageTrackingNo");
    localStorage.removeItem("packageTrackingLink");
    localStorage.removeItem("countryCode");
    localStorage.removeItem("arrivalDate");
    localStorage.removeItem("sendEmail");

    //consignee details storage
    localStorage.removeItem("consigneecontactName");
    localStorage.removeItem("consigneecompanyName");
    localStorage.removeItem("consigneeemail");
    localStorage.removeItem("consigneephone");
    localStorage.removeItem("consigneepostal");
    localStorage.removeItem("consigneecountry");
    localStorage.removeItem("consigneecity");
    localStorage.removeItem("consigneeprovince");
    localStorage.removeItem("consigneeaddress");

    //destination details storage
    localStorage.removeItem("destcontactName");
    localStorage.removeItem("destcompanyName");
    localStorage.removeItem("destemail");
    localStorage.removeItem("destphone");
    localStorage.removeItem("destpostal");
    localStorage.removeItem("destcountry");
    localStorage.removeItem("destprovince");
    localStorage.removeItem("destaddress");
    localStorage.removeItem("destlicense");
    localStorage.removeItem("desttax");
    localStorage.removeItem("setPhone");
  };

  return (
    <div
      className="xl:col-span-9 lg:col-span-8 bg-themeSecondary py-6 sm:px-8 px-4 flex flex-col 
      justify-between gap-y-8"
    >
      {loading ? (
        <Loader2 />
      ) : (
        <div className="space-y-8">
          <h1 className="font-medium text-2xl text-themeBlue">Order Summary</h1>
          <div
            className={`bg-white px-6 pt-8 ${
              pack ? "pb-10 space-y-4" : "pb-6"
            } rounded-lg`}
          >
            <h2 className="font-medium text-2xl text-themeBlue flex items-center justify-between">
              Package Details
              {!pack ? (
                <FaChevronDown onClick={closePack} className="cursor-pointer" />
              ) : (
                <FaChevronUp onClick={openPack} className="cursor-pointer" />
              )}
            </h2>
            <div
              className={`${pack ? "flex" : "hidden"} items-center gap-x-12`}
            >
              <div className="space-y-2">
                <h4 className="font-medium text-base">Quantity</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.package_detail?.package_qty ?? ""} Packages
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Billable weight</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.package_detail?.billable_weight ?? ""} KG
                </p>
              </div>
            </div>

            <div className="">
              {pack &&
                packages.slice(0, visiblePackages).map((pkg) => (
                <div className="card bg-white shadow-lg rounded p-4 mb-4" key={pkg.id}>
                  <div className="grid grid-cols-2 lg:grid-cols-6 gap-4">
                    <div>
                      <p>Package ID</p>
                      <p>{pkg.id}</p>
                    </div>
                    <div>
                      <p>Weight</p>
                      <p>{pkg.captureWeight} kg</p>
                    </div>
                    <div>
                      <p>Quantity</p>
                      <p>{pkg.qty}</p>
                    </div>
                    <div className="lg:col-span-2">
                      <p>Billable Weight</p>
                      <p>{pkg.captureBillableWeight} kg</p>
                    </div>
                    <div className="lg:col-span-2">
                      <p>Volumetric Weight</p>
                      <p>{pkg.captureVolumetricWeight} kg</p>
                    </div>
                    <div>
                      <p>Dimensions</p>
                      <p>
                        {pkg.captureLength} x {pkg.captureWidth} x {pkg.captureHeight} cm
                      </p>
                    </div>
                  </div>
                </div>
              ))}
              {pack && packages.length > visiblePackages ? (
                <div className="flex justify-center">
                  <button
                    className="border border-themeBlue text-themeBlue px-4 py-2 rounded-lg hover:bg-themeBlue hover:text-white"
                    onClick={() => setVisiblePackages((prev) => prev + 25)}
                  >
                    Show More Packages
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            className={`bg-white px-6 pt-8 ${
              prod ? "pb-10 space-y-4" : "pb-6"
            } rounded-lg`}
          >
            <h2 className="font-medium text-2xl text-themeBlue flex items-center justify-between">
              Product Info
              {prod ? (
                <FaChevronUp onClick={closeProd} className="cursor-pointer" />
              ) : (
                <FaChevronDown onClick={openProd} className="cursor-pointer" />
              )}
            </h2>
            <div
              className={`${prod ? "flex" : "hidden"} items-center gap-x-12`}
            >
              <div className="space-y-2">
                <h4 className="font-medium text-base">Quantity</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.product_info?.product_qty ?? ""} Products
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Billable weight</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.product_info?.billable_weight ?? ""} KG
                </p>
              </div>
            </div>
            <div>
              <div className="">
                {prod &&
                  products.slice(0, visibleProducts).map((product) => (
                  <div className="card bg-white shadow-lg rounded p-4 mb-4" key={product.id}>
                    <div className="grid grid-cols-2 lg:grid-cols-6 gap-4">
                      <div>
                        <p>Product ID</p>
                        <p>{product.id}</p>
                      </div>
                      <div>
                        <p>Description</p>
                        <p>{product.description || "-"}</p>
                      </div>
                      <div>
                        <p>Weight</p>
                        <p>{product.weight}kg</p>
                      </div>
                      <div>
                        <p>HsCode</p>
                        <p>{product.HsCode?.HsCode}</p>
                      </div>
                      <div>
                        <p>Quantity</p>
                        <p>{product.qty}</p>
                      </div>
                      <div>
                        <p>Price</p>
                        <p>${product.price}</p>
                      </div>
                    </div>
                  </div>
                ))}
                {prod && products.length > visibleProducts ? (
                  <div className="flex justify-center">
                    <button
                      className="border border-themeBlue text-themeBlue px-4 py-2 rounded-lg hover:bg-themeBlue hover:text-white"
                      onClick={() => setVisibleProducts((prev) => prev + 25)}
                    >
                      Show More Products
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div
            className={`bg-white px-6 pt-8 ${
              supp ? "pb-10 space-y-4" : "pb-6"
            } rounded-lg`}
          >
            <h2 className="font-medium text-2xl text-themeBlue flex items-center justify-between">
              Supplier Details
              {supp ? (
                <FaChevronUp onClick={closeSupp} className="cursor-pointer" />
              ) : (
                <FaChevronDown onClick={openSupp} className="cursor-pointer" />
              )}
            </h2>
            <div
              className={`${supp ? "grid" : "hidden"} grid-cols-1 md:grid-cols-3 gap-6`}
            >
              <div className="space-y-2">
                <h4 className="font-medium text-base">Supplier Name</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.supplier?.supplier_name ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Email</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.supplier?.supplier_email ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Phone</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.supplier?.supplier_phone ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Arrival Date</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.SupplierDetail?.arrivalDate ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Tracking No</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.SupplierDetail?.trackingNo ?? "-"}
                </p>
              </div>
              <div className="space-y-2 md:col-span-2">
                <h4 className="font-medium text-base">Tracking Link</h4>
                <p className="font-normal text-base text-black text-opacity-60 break-all">
                  {data?.data?.order?.SupplierDetail?.trackingLink ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Supply List Image</h4>
                <p className="font-normal text-base text-black text-opacity-60 break-all">
                  {data?.data?.order?.SupplierDetail?.SupplyListImage ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Invoice Image</h4>
                <p className="font-normal text-base text-black text-opacity-60 break-all">
                  {data?.data?.order?.SupplierDetail?.invoiceImage ?? "-"}
                </p>
              </div>
            </div>
          </div>
          <div
            className={`bg-white px-6 pt-8 ${
              dest ? "pb-10 space-y-4" : "pb-6"
            } rounded-lg`}
          >
            <h2 className="font-medium text-2xl text-themeBlue flex items-center justify-between">
              Destination Details
              {dest ? (
                <FaChevronUp onClick={closeDest} className="cursor-pointer" />
              ) : (
                <FaChevronDown onClick={openDest} className="cursor-pointer" />
              )}
            </h2>
            <div
              className={`${dest ? "grid" : "hidden"} grid-cols-1 md:grid-cols-3 gap-6`}
            >
              <div className="space-y-2">
                <h4 className="font-medium text-base">Person Name</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.destination?.person_name ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Company Name</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.destination?.company_name ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Email</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.destination?.email ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Phone</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.destination?.phone ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Country</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.DestinationDetail?.country ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">City</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.DestinationDetail?.city ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Province</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.DestinationDetail?.province ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Postal Code</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.DestinationDetail?.postalCode ?? "-"}
                </p>
              </div>
              <div className="space-y-2 md:col-span-2">
                <h4 className="font-medium text-base">Address</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.DestinationDetail?.address ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">License</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.DestinationDetail?.license ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">VAT / Tax No</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.order?.DestinationDetail?.vatNo ?? "-"}
                </p>
              </div>
            </div>
          </div>
          <div
            className={`bg-white px-6 pt-8 ${
              consigneeOpen ? "pb-10 space-y-4" : "pb-6"
            } rounded-lg`}
          >
            <h2 className="font-medium text-2xl text-themeBlue flex items-center justify-between">
              Consignee Details
              {consigneeOpen ? (
                <FaChevronUp onClick={closeConsignee} className="cursor-pointer" />
              ) : (
                <FaChevronDown onClick={openConsignee} className="cursor-pointer" />
              )}
            </h2>
            <div
              className={`${consigneeOpen ? "grid" : "hidden"} grid-cols-1 md:grid-cols-3 gap-6`}
            >
              <div className="space-y-2">
                <h4 className="font-medium text-base">Contact Name</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.contactName ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Company Name</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.companyName ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Email</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.email ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Phone</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.phone ?? ""}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Country</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.country ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">City</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.city ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Province</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.province ?? "-"}
                </p>
              </div>
              <div className="space-y-2">
                <h4 className="font-medium text-base">Postal Code</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.postalCode ?? "-"}
                </p>
              </div>
              <div className="space-y-2 md:col-span-2">
                <h4 className="font-medium text-base">Address</h4>
                <p className="font-normal text-base text-black text-opacity-60">
                  {data?.data?.consignee?.address ?? "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      <section
        className={` bg-white rounded-lg py-8 px-6 box-border space-y-8`}
      >
        <div className="flex items-center gap-x-4">
          <div>
            <img
              src="images/sendParcel/invoice.webp"
              alt="box"
              className="w-10"
            />
          </div>
          <h1 className="font-medium text-2xl text-themeBlue">Order Details</h1>
        </div>
        <div>
          <ul className="space-y-4">
            <li className="flex justify-end items-center gap-x-14">
              <h5 className="font-medium text-base text-black text-opacity-40">
                Freight Price({data?.data?.kg}Kg x ${data?.data?.companyTax})
              </h5>
              <h6 className="font-normal text-base">
                ${data?.data?.freighPrice ?? "0.00"}
              </h6>
            </li>
            <li className="flex justify-end items-center gap-x-14">
              <h5 className="font-medium text-base text-black text-opacity-40">
                Import VAT
              </h5>
              <h6 className="font-normal text-base">
                ${data?.data?.vatTax ?? "0.00"}
              </h6>
            </li>
            <li className="flex justify-end items-center gap-x-14">
              <h5 className="font-medium text-base text-black text-opacity-40">
                Import Duties
              </h5>
              <h6 className="font-normal text-base">
                ${data?.data?.importDuty ?? "0.00"}
              </h6>
            </li>
            <li className="flex justify-end items-center gap-x-14">
              <h5 className="font-medium text-base text-black text-opacity-40">
                Custom Clearance Fee
              </h5>
              <h6 className="font-normal text-base">
                ${data?.data?.customerClearanceFee ?? "0.00"}
              </h6>
            </li>
            <li className="flex justify-end items-center gap-x-14">
              <h5 className="font-medium text-base text-black text-opacity-40">
                Repacking Fee
              </h5>
              <h6 className="font-normal text-base">
                ${data?.data?.repacking ?? "0.00"}
              </h6>
            </li>
            <li className="flex justify-end items-center gap-x-14">
              <h5 className="font-medium text-base text-black text-opacity-40">
                Insurance
              </h5>
              <h6 className="font-normal text-base">
                ${data?.data?.insurance ?? "0.00"}
              </h6>
            </li>
            {/* <li className="flex justify-end items-center gap-x-14">
              <h5 className="font-medium text-base text-black text-opacity-40">
                Billable Price
              </h5>
              <h6 className="font-normal text-base">${data?.data?.billablePrice?? "0.00"}</h6>
            </li> */}
            <li className="flex justify-end items-center gap-x-12">
              <h1 className="font-medium text-4xl">
                ${data?.data?.totalPrice ?? "0.00"}
              </h1>
            </li>
          </ul>
        </div>
      </section>
      <div className="flex sm:flex-row flex-col sm:justify-end sm:items-center gap-x-4 gap-y-3">
        <div>
          <Link
            className="bg-transparent text-themeBlue font-medium xl:text-xl lg:text-lg py-3 px-12 rounded-lg 
              border border-themeBlue flex justify-center items-center gap-x-2 hover:bg-themeBlue 
            hover:text-white sm:w-auto w-full"
            to="/destination_details"
          >
            <FaArrowLeft />
            <span>Back</span>
          </Link>
        </div>
        <div>
          <button
            onClick={() => place_order()}
            className="bg-themeBlue text-white font-medium xl:text-xl lg:text-lg py-3 px-12 rounded-lg 
              border border-themeBlue flex justify-center items-center gap-x-2 hover:bg-transparent hover:text-themeBlue 
              sm:w-auto w-full"
          >
            <span>Place Order</span>
            <FaArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
}
